(function () {
  'use strict';

  if (window.__gllfMegaMenuLoaded) return;
  window.__gllfMegaMenuLoaded = true;

  var ZONE_EVENTS = [
    'gllf:zone-change', 'gllf:zone-changed', 'gllf:hardiness-zone-change',
    'gllf-zone-updated', 'hardinessZoneChanged', 'gllf:zoneUpdated',
    'gllf:destination-updated'
  ];
  var RESTRICTED_PLANT_STATES = ['AZ', 'CA', 'HI', 'ID', 'NV', 'OR', 'UT', 'WA'];

  function parse(value) {
    if (!value) return {};
    try {
      var parsed = JSON.parse(value);
      return parsed && typeof parsed === 'object' ? parsed : { zone: parsed };
    } catch (error) {
      return { zone: value };
    }
  }

  function readDestination() {
    try {
      return parse(window.localStorage.getItem('gllf_destination_v1'));
    } catch (error) {
      return {};
    }
  }

  function emit(name, detail) {
    var payload = Object.assign({ component: 'mega_menu' }, detail || {});
    document.dispatchEvent(new CustomEvent('gllf:analytics', { detail: { name: name, data: payload } }));
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({ event: name }, payload));
    }
  }

  function updatePlantStatus(root, detail) {
    var destination = Object.assign({}, readDestination(), detail || {});
    var state = String(destination.state || '').trim().toUpperCase();
    root.querySelectorAll('[data-gllf-plant-status]').forEach(function (status) {
      if (!status.dataset.gllfDefaultStatus) status.dataset.gllfDefaultStatus = status.textContent.trim();
      if (RESTRICTED_PLANT_STATES.indexOf(state) === -1) {
        status.textContent = status.dataset.gllfDefaultStatus;
        return;
      }
      status.textContent = 'Container plants cannot ship to this destination. Explore eligible bare-root lavender for the March 1–May 31 window, or choose Wednesday/Friday local pickup.';
    });
  }

  function initDesktop(root) {
    var desktop = root.matches && root.matches('[data-gllf-mega-desktop]')
      ? root
      : root.querySelector('[data-gllf-mega-desktop]');
    if (!desktop) return;
    var disclosures = Array.prototype.slice.call(desktop.querySelectorAll('[data-gllf-mega-disclosure]'));
    var hoverMode = desktop.dataset.openMode === 'mousehover';
    var openTimer;
    var closeTimer;

    function close(disclosure, restoreFocus) {
      if (!disclosure || !disclosure.open) return;
      disclosure.open = false;
      var trigger = disclosure.querySelector(':scope > summary');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (restoreFocus && trigger) trigger.focus();
    }

    function closeAll(except) {
      disclosures.forEach(function (item) {
        if (item !== except) close(item, false);
      });
    }

    disclosures.forEach(function (disclosure) {
      var trigger = disclosure.querySelector(':scope > summary');
      if (!trigger) return;
      trigger.setAttribute('aria-expanded', disclosure.open ? 'true' : 'false');
      disclosure.addEventListener('toggle', function () {
        trigger.setAttribute('aria-expanded', disclosure.open ? 'true' : 'false');
        if (disclosure.open) {
          closeAll(disclosure);
          emit('gllf_mega_opened', { category: disclosure.dataset.category || '' });
        }
      });
      trigger.addEventListener('click', function () {
        emit('gllf_mega_category_selected', { category: disclosure.dataset.category || '' });
      });
      if (hoverMode && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        disclosure.addEventListener('mouseenter', function () {
          window.clearTimeout(closeTimer);
          openTimer = window.setTimeout(function () {
            closeAll(disclosure);
            disclosure.open = true;
          }, 140);
        });
        disclosure.addEventListener('mouseleave', function () {
          window.clearTimeout(openTimer);
          closeTimer = window.setTimeout(function () { close(disclosure, false); }, 220);
        });
      }
    });

    document.addEventListener('click', function (event) {
      if (!desktop.contains(event.target)) closeAll();
    });
    desktop.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        var active = disclosures.find(function (item) { return item.open; });
        close(active, true);
        return;
      }
      var trigger = event.target.closest('[data-gllf-mega-disclosure] > summary');
      if (!trigger) return;
      var disclosure = trigger.parentElement;
      if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
        event.preventDefault();
        closeAll(disclosure);
        disclosure.open = true;
        var firstLink = disclosure.querySelector('.gllf-mega-desktop__panel a[href]');
        if (event.key === 'ArrowDown' && firstLink) firstLink.focus();
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        close(disclosure, true);
      }
    });
  }

  function initMobile(root) {
    var mobile = root.matches && root.matches('[data-gllf-mega-mobile]')
      ? root
      : root.querySelector('[data-gllf-mega-mobile]');
    if (!mobile) return;
    var drawerRoot = mobile.querySelector('[data-gllf-mobile-root]');
    var drawer = mobile.querySelector('.gllf-mega-mobile__drawer');
    var drawerTrigger = drawerRoot.querySelector(':scope > summary');
    var menuScreen = mobile.querySelector('[data-gllf-mobile-screen="menu"]');
    var panels = Array.prototype.slice.call(mobile.querySelectorAll('[data-gllf-mobile-screen^="panel-"]'));
    var previousFocus;
    var submenuTrigger;
    var originalOverflow = '';

    function showMenu(focusBack) {
      panels.forEach(function (panel) { panel.hidden = true; });
      mobile.querySelectorAll('[data-gllf-mobile-open]').forEach(function (button) {
        button.setAttribute('aria-expanded', 'false');
      });
      menuScreen.hidden = false;
      if (focusBack) {
        if (submenuTrigger && typeof submenuTrigger.focus === 'function') submenuTrigger.focus();
      }
    }

    function closeDrawer() {
      drawerRoot.open = false;
    }

    drawerRoot.addEventListener('toggle', function () {
      if (drawerTrigger) drawerTrigger.setAttribute('aria-expanded', drawerRoot.open ? 'true' : 'false');
      if (drawerRoot.open) {
        previousFocus = document.activeElement;
        originalOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        window.setTimeout(function () {
          var focusSearch = mobile.dataset.gllfMobileFocusSearch === 'true';
          var target = focusSearch
            ? mobile.querySelector('[data-gllf-mobile-screen="menu"] input[type="search"]')
            : mobile.querySelector('.gllf-mega-mobile__close');
          if (target) target.focus();
        }, 0);
        emit('gllf_mega_opened', { category: 'mobile' });
      } else {
        document.documentElement.style.overflow = originalOverflow;
        showMenu(false);
        if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
      }
    });

    mobile.querySelectorAll('[data-gllf-mobile-close]').forEach(function (button) {
      button.addEventListener('click', closeDrawer);
    });
    mobile.querySelectorAll('[data-gllf-mobile-open]').forEach(function (button) {
      button.addEventListener('click', function () {
        var panel = mobile.querySelector('[data-gllf-mobile-screen="panel-' + button.dataset.gllfMobileOpen + '"]');
        if (!panel) return;
        submenuTrigger = button;
        menuScreen.hidden = true;
        panels.forEach(function (item) { item.hidden = item !== panel; });
        mobile.querySelectorAll('[data-gllf-mobile-open]').forEach(function (item) {
          item.setAttribute('aria-expanded', item === button ? 'true' : 'false');
        });
        var back = panel.querySelector('[data-gllf-mobile-back]');
        if (back) back.focus();
        emit('gllf_mega_category_selected', { category: button.dataset.gllfMobileOpen || '', surface: 'mobile' });
      });
    });
    mobile.querySelectorAll('[data-gllf-mobile-back]').forEach(function (button) {
      button.addEventListener('click', function () { showMenu(true); });
    });
    mobile.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeDrawer();
        return;
      }
      if (event.key !== 'Tab' || !drawerRoot.open || !drawer) return;
      var focusable = Array.prototype.slice.call(drawer.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter(function (element) {
        return !element.hidden && element.getClientRects().length > 0;
      });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  function init(root) {
    if (!root || root.dataset.gllfMegaReady === 'true') return;
    root.dataset.gllfMegaReady = 'true';
    updatePlantStatus(root);
    ZONE_EVENTS.forEach(function (name) {
      function handleZoneEvent(event) {
        updatePlantStatus(root, event.detail);
      }
      window.addEventListener(name, handleZoneEvent);
      document.addEventListener(name, handleZoneEvent);
    });
    window.addEventListener('storage', function (event) {
      if (event.key === 'gllf_destination_v1') updatePlantStatus(root);
    });
    root.addEventListener('click', function (event) {
      var link = event.target.closest('a[data-gllf-mega-link]');
      if (!link) return;
      var category = link.dataset.gllfMegaCategory || '';
      var destinationType = link.dataset.gllfMegaType || 'link';
      var label = (link.textContent || '').trim().toLowerCase();
      emit('gllf_mega_link_selected', {
        category: category,
        destination_type: destinationType
      });
      if (destinationType === 'feature') emit('gllf_mega_featured_promotion_selected', { category: category });
      if (label.indexOf('plant finder') !== -1) emit('gllf_mega_plant_finder_selected', { category: category });
      if (label.indexOf('simulator') !== -1) emit('gllf_mega_simulator_selected', { category: category });
      if (category.indexOf('wholesale') !== -1 && (label.indexOf('apply') !== -1 || label.indexOf('request a quote') !== -1)) {
        emit('gllf_mega_wholesale_application_selected', { category: category });
      }
      if (link.hasAttribute('data-gllf-mega-restriction-alternative')) {
        emit('gllf_mega_restriction_alternative_selected', { category: category });
      }
    });
    var searchForm = root.querySelector('.gllf-mega-mobile__search');
    if (searchForm) searchForm.addEventListener('submit', function () {
      emit('gllf_mega_search_submitted', { surface: 'mobile' });
    });
    initDesktop(root);
    initMobile(root);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-gllf-mega]').forEach(init);
  }

  function mountMobile(scope) {
    (scope || document).querySelectorAll('.gllf-mega-section .gllf-mega-mobile').forEach(function (mobile) {
      var owner = mobile.closest('[data-gllf-mega-section]');
      var header = document.querySelector('header.header');
      if (!header) return;
      if (owner) {
        mobile.dataset.gllfMegaOwner = owner.dataset.gllfMegaSection || '';
        mobile.dataset.gllfMobileFocusSearch = owner.dataset.gllfMobileFocusSearch || 'false';
      }
      var originalDrawer = header.querySelector(':scope > header-drawer.mobile-drawer');
      header.insertBefore(mobile, originalDrawer || header.firstElementChild);
    });
  }

  function mountDesktop(scope) {
    (scope || document).querySelectorAll('.gllf-mega-section .gllf-mega-row').forEach(function (row) {
      var owner = row.closest('[data-gllf-mega-section]');
      var stickyHeader = document.querySelector('sticky-header.header-wrapper, .header-wrapper');
      if (!stickyHeader) return;
      if (owner) row.dataset.gllfMegaOwner = owner.dataset.gllfMegaSection || '';
      stickyHeader.appendChild(row);
    });
  }

  function initGlobalSearchTracking() {
    if (document.documentElement.dataset.gllfSearchTrackingReady === 'true') return;
    document.documentElement.dataset.gllfSearchTrackingReady = 'true';
    document.addEventListener('click', function (event) {
      var result = event.target.closest('[data-gllf-search-type]');
      if (!result) return;
      emit('gllf_search_result_type_selected', {
        result_type: result.dataset.gllfSearchType || 'unknown'
      });
    });
  }

  function activateReplacement() {
    var desktop = document.querySelector('[data-gllf-mega-desktop]');
    var mobile = document.querySelector('header.header [data-gllf-mega-mobile]');
    if (desktop && mobile) document.documentElement.classList.add('gllf-mega-active');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      mountDesktop(document);
      mountMobile(document);
      initAll(document);
      initGlobalSearchTracking();
      activateReplacement();
    });
  } else {
    mountDesktop(document);
    mountMobile(document);
    initAll(document);
    initGlobalSearchTracking();
    activateReplacement();
  }
  document.addEventListener('shopify:section:load', function (event) {
    mountDesktop(event.target);
    mountMobile(event.target);
    initAll(document);
    activateReplacement();
  });
  document.addEventListener('shopify:section:unload', function (event) {
    var owner = event.target.querySelector('[data-gllf-mega-section]');
    if (!owner) return;
    document.querySelectorAll('[data-gllf-mega-owner="' + owner.dataset.gllfMegaSection + '"]').forEach(function (mobile) {
      mobile.remove();
    });
    window.setTimeout(function () {
      if (!document.querySelector('[data-gllf-mega-section]')) {
        document.documentElement.classList.remove('gllf-mega-active');
      }
    }, 0);
  });
})();
